export default __webpack_public_path__ + "static/bg_desktop-1909c9d232150c3e2e0db48b10efa050.jpg";